import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import kliqon from '../../Assets/kliqonlogo.jpg';
import { Instagram, Mail, Underline } from 'lucide-react';

const Footer = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    if (expandedSection === section) {
      setExpandedSection(null);
    } else {
      setExpandedSection(section);
    }
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-links-container">
          {/* Quick Link Section */}
          <div className="footer-section">
            <div 
              className="footer-heading" 
              onClick={() => toggleSection('links')}
            >
              <h4>QUICK LINKS</h4>
              <span className="toggle-icon">{expandedSection === 'links' ? '−' : '+'}</span>
            </div>
            <nav className={`footer-nav ${expandedSection === 'links' ? 'expanded' : ''}`}>
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/collection">Shop The Collection</Link>
              <Link to="/customize" >Design Your Piece</Link>
              <Link to="/about">Who we are</Link>
              <Link to="/blogs" >Blogs</Link>
            </nav>
          </div>

          {/* Policies Section */}
          <div className="footer-section">
            <div 
              className="footer-heading" 
              onClick={() => toggleSection('policies')}
            >
              <h4>POLICIES</h4>
              <span className="toggle-icon">{expandedSection === 'policies' ? '−' : '+'}</span>
            </div>
            <nav className={`footer-nav ${expandedSection === 'policies' ? 'expanded' : ''}`}>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/return-policy">Return Policy</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/shipping-policy">Shipping Policy</Link>
              <Link to="/ContactUS">Contact US</Link>
            </nav>
          </div>

          {/* Social Media Section */}
          <div className="footer-section">
            <div 
              className="footer-heading" 
              onClick={() => toggleSection('social')}
            >
              <h4>CONNECT WITH US</h4>
              <span className="toggle-icon">{expandedSection === 'social' ? '−' : '+'}</span>
            </div>
            <div className={`social-links ${expandedSection === 'social' ? 'expanded' : ''}`}>
              <a href="https://www.instagram.com/wearestudiocircle" target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={20} strokeWidth={2} />
                <span>Instagram</span>
              </a>
              <a href="mailto:chatwiththecircle@gmail.com" className="social-link">
                <Mail size={20} strokeWidth={2} />
                <span>Mail</span>
              </a>
            </div>
          </div>
        </div>

        {/* Logo Column - visible only on desktop */}
        <div className="footer-branding">
          <div className="branding-content">
            <p className="crafted-text">CRAFTED WITH CARE BY</p>
            <a href="https://www.kliqontech.com" target="_blank" rel="noopener noreferrer">
              <img src={kliqon} alt="Kliqon Logo" className="footer-logo" />
            </a>
          </div>
        </div>

        {/* Logo at the top for mobile */}
        <div className="footer-logo-mobile">
          <p className="crafted-text">CRAFTED WITH CARE</p>
          <a href="https://www.kliqontech.com" target="_blank" rel="noopener noreferrer">
            <img src={kliqon} alt="Kliqon Logo" className="footer-logo" />
          </a>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Studio Circle. All Rights Reserved. Powered by <a href="https://www.kliqontech.com" target="_blank" rel="noopener noreferrer" style={{textDecoration:"Underline",color:"blue"}}>KliqOn Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
